import { render } from "./ClientToProspectModal.vue?vue&type=template&id=045ef5e1&scoped=true"
import script from "./ClientToProspectModal.vue?vue&type=script&lang=js"
export * from "./ClientToProspectModal.vue?vue&type=script&lang=js"

import "./ClientToProspectModal.vue?vue&type=style&index=0&id=045ef5e1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045ef5e1"]])

export default __exports__